import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import {NO_SP_CHANGE, SimilarPatientsDataState} from '../state';
import {StateTypes} from "@ispm-client/modules/similar-patients/store/actions/similar-patients.actions";
import { ISimilarPatient } from '@ispm-client/modules/similar-patients/models/similar-patient.interface';

export const selectSimilarPatientsDataState: MemoizedSelector<object, SimilarPatientsDataState>
    = createFeatureSelector<SimilarPatientsDataState>('similarPatientsData');

/** a listener to the current-patient **/
const getCurrentPatientData = (state: SimilarPatientsDataState): ISimilarPatient => !!state ? state.currentPatient : NO_SP_CHANGE;

/** a listener to the similar-patients data **/
const getSimilarPatientsData = (state: SimilarPatientsDataState): any => {

  if (state) {
    return state.patientsData;
  }

  return NO_SP_CHANGE;

};

/**
 * a listener to CHANGES of the similar-patients data.
 * this event is invoked ONLY when new similar-patients-data is being set
 **/
const searchSimilarPatientsResults = (state: SimilarPatientsDataState): any => {

  if (state && state.stateSuccess &&
    state.stateSuccess.stateType === StateTypes.SEARCH_SIMILAR_PATIENTS) {

    return state.patientsData;
  }

  return NO_SP_CHANGE;
};

/**
 * a listener to errors that occur while trying to retrieve current-patients OR similar-patients-data
 * the exact event on which this event occurs is indicated by the 'stateType' value
 **/
const getError = (state: SimilarPatientsDataState): any => {
  if (state && state.error) {
    return { stateType: state.error.stateType, error: state.error };
  }
  return null;
};

export const selectCurrentPatientData: MemoizedSelector<object, any>
    = createSelector(selectSimilarPatientsDataState, getCurrentPatientData);

export const selectSimilarPatientsData: MemoizedSelector<object, any>
    = createSelector(selectSimilarPatientsDataState, getSimilarPatientsData);

export const selectSimilarPatientsSearchResult: MemoizedSelector<object, any>
    = createSelector(selectSimilarPatientsDataState, searchSimilarPatientsResults);

export const selectSimilarPatientsError: MemoizedSelector<object, any>
    = createSelector(selectSimilarPatientsDataState, getError);
